import React, { useState } from 'react'

import { SftpSetting } from 'types/GlobalSource'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import SimpleTable from 'components_new/molecules/SimpleTable'

import ResetPasswordDialog from './ResetPasswordDialog'

/** The SFTP server is the same for every customer; only the account differs. */
const SFTP_HOST =
  process.env.NODE_ENV === 'development' ? 'localhost' : 'sftp.homepal.se'
const SFTP_PORT = process.env.NODE_ENV === 'development' ? 2222 : 22

interface SftpPanelProps {
  sftpSetting: SftpSetting
}

const SftpPanel = (props: SftpPanelProps) => {
  const { sftpSetting } = props

  const [resetOpen, setResetOpen] = useState(false)

  return (
    <Box>
      <SimpleTable
        border={true}
        columns={[{ align: 'left' }, { align: 'right' }]}
        rows={[
          { cells: [<b key="host">Host</b>, SFTP_HOST] },
          { cells: [<b key="port">Port</b>, String(SFTP_PORT)] },
          {
            cells: [
              <b key="username">Användarnamn</b>,
              sftpSetting.attributes.username
            ]
          },
          {
            cells: [
              <b key="password">Lösenord</b>,
              sftpSetting.attributes.password
            ]
          }
        ]}
        size="medium"
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button onClick={() => setResetOpen(true)} variant="text">
          Generera nytt lösenord
        </Button>
      </Box>

      <Text color="text.secondary" variant="caption">
        Filer som levereras till servern läses in automatiskt.
      </Text>

      <ResetPasswordDialog
        onClose={() => setResetOpen(false)}
        open={resetOpen}
        sftpSetting={sftpSetting}
      />
    </Box>
  )
}

export default SftpPanel
